// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBWR41YNq2SYLXl0ONd60ScEdtUu1tZaeo",
    authDomain: "montauk-edge.firebaseapp.com",
    projectId: "montauk-edge",
    storageBucket: "montauk-edge.firebasestorage.app",
    messagingSenderId: "1018072169730",
    appId: "1:1018072169730:web:91e1ca9dca6a9b7bd0d61b"
};
// Initialize Firebase

export const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);